var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-card',{attrs:{"title":"Edit User"}},[_c('b-card-text',[_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('user-form',{attrs:{"errors":_vm.errors}}),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }